<template>
  <div class="flex flex-col sm:flex-row donation-box">
    <div
      class="w-full h-1/4 sm:h-full sm:w-1/2 img-box bg-center bg-cover"
    ></div>
    <div
      class="h-3/4 sm:h-full bg-box bg-center bg-cover sm:w-1/2 flex flex-col justify-center items-center px-8 sm:px-4 md:px-7 xl:px-12"
    >
      <svg
        class="donation-logo"
        viewBox="0 0 295 129"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.7388 70.0038C34.5104 68.4679 32.8958 66.5514 31.1564 64.5674C31.3565 64.3194 41.0533 50.6713 39.0221 43.6948C37.6482 38.9763 36.6465 36.3883 34.8716 33.7157C32.8629 30.6914 31.154 27.8462 27.7004 25.9126C29.2785 26.9454 31.1485 33.499 31.4275 37.778C32.2223 49.9648 23.8413 56.8789 23.8413 56.8789C23.8413 56.8789 16.5621 51.8488 15.0905 40.339C14.4778 35.5478 15.5945 27.9048 18.9357 25.7451C16.5251 26.0694 13.5475 30.2615 12.1469 33.0092C7.80283 41.5319 6.86976 42.1082 8.63452 48.9413C10.865 57.5782 16.4789 64.3242 16.7145 64.5602C14.8197 66.4927 12.8989 68.4801 11.2558 70.4836L11.2138 70.5345C7.46761 75.1024 4.93174 80.4775 0.458008 90.3145L11.0448 104.591C10.1854 96.4899 16.0619 78.9308 23.9013 72.1908C29.5731 76.2815 38.2552 96.2838 37.435 102.863L48.5627 89.7836C46.1093 83.8234 37.8983 72.7028 35.7388 70.0038Z"
          fill="#D89C11"
        />
        <path
          d="M22.6854 33.7748C28.1015 33.4216 31.045 35.6587 33.2824 38.8378C33.2824 34.9773 30.5741 27.8285 27.7008 25.7361C25.4229 24.62 20.6543 24.7966 18.9361 25.5687C15.8559 27.4755 13.8545 35.1323 13.8545 39.0734C15.3264 35.5294 17.2688 34.128 22.6854 33.7748Z"
          fill="#D89C11"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.6842 33.4215C28.0967 33.0144 31.0439 35.3054 33.2813 38.4846C33.2813 34.624 30.573 27.4754 27.6997 25.3828C25.4218 24.2667 20.4766 24.4434 18.7584 25.2154C16.2645 27.1727 15.4201 32.5904 15.1562 36.3648C16.2938 34.9438 17.7068 33.7958 22.6842 33.4215Z"
          fill="url(#paint0_radial_11002_1221)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.5633 69.4748C34.335 67.9389 32.7204 66.0224 30.981 64.0384C31.1811 63.7904 40.8779 50.1423 38.8467 43.1656C37.4728 38.4472 36.471 35.8592 34.6962 33.1866C32.6875 30.1623 30.9786 27.3171 27.525 25.3835C29.103 26.4164 30.9731 32.9699 31.2521 37.2489C32.0469 49.4358 23.6659 56.3499 23.6659 56.3499C23.6659 56.3499 16.3865 51.3198 14.915 39.8099C14.3024 35.0187 15.4191 27.3758 18.7603 25.2161C16.3496 25.5403 13.3721 29.7324 11.9715 32.4801C7.6274 41.0028 6.69434 41.5791 8.4591 48.4123C10.6896 57.0492 16.3034 63.7952 16.539 64.0312C14.6443 65.9637 12.7235 67.9511 11.0804 69.9545L11.0384 70.0055C7.29219 74.5733 2.70984 80.6978 0.516602 90.1373L10.6285 100.887C10.7018 93.4587 15.8864 78.4017 23.7259 71.6617C29.3976 75.7524 39.1373 94.5184 38.0519 101.097L48.3872 89.7844C45.9339 83.8241 37.7229 72.1737 35.5633 69.4748Z"
          fill="url(#paint1_radial_11002_1221)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.74 69.4748C34.5117 67.9389 32.897 66.0224 31.1576 64.0384C31.3578 63.7904 41.0545 50.1423 39.0233 43.1656C37.6494 38.4472 36.6476 35.8592 34.8728 33.1866C32.8642 30.1623 31.1552 27.3171 27.7016 25.3835C29.2796 26.4164 31.1497 32.9699 31.4288 37.2489C32.2235 49.4358 23.8425 56.3499 23.8425 56.3499C23.8425 56.3499 16.5632 51.3198 15.0917 39.8099C14.479 35.0187 15.5957 27.3758 18.9369 25.2161C16.5263 25.5403 13.5487 29.7324 12.1481 32.4801C7.80402 41.0028 6.87096 41.5791 8.63572 48.4123C10.8662 57.0492 16.48 63.7952 16.7156 64.0312C14.8209 65.9637 12.9002 67.9511 11.2571 69.9545L11.215 70.0055C7.46881 74.5733 2.70984 80.6978 0.516602 90.1373L10.8051 103.89C9.89218 96.0785 16.063 78.4017 23.9025 71.6617C29.5742 75.7524 38.6074 95.7548 37.5221 102.334L48.5638 89.7844C46.1105 83.8241 37.8995 72.1737 35.74 69.4748Z"
          fill="url(#paint2_radial_11002_1221)"
        />
        <path
          d="M35.7397 70.1813C34.5113 68.6454 32.8967 66.7289 31.1573 64.7449C31.1776 64.7202 27.5842 60.2015 23.0484 56.2719C23.0438 56.268 23.0445 56.2618 23.0426 56.2569C21.1108 54.6194 16.2625 49.6754 15.0913 40.5163C14.4786 35.7252 15.772 27.3758 19.1132 25.2161C16.7025 25.5403 13.5484 30.4389 12.1478 33.1866C7.80369 41.7092 6.76023 41.8742 8.28215 48.7655C10.3198 57.9937 16.4796 64.5017 16.7152 64.7376C16.6467 64.8078 21.0076 69.3215 21.9149 70.2704C22.6327 71.0218 23.4405 71.8318 24.2692 72.8378C29.7918 78.4375 37.2677 92.1928 37.2593 103.179L48.6263 89.9424C46.1728 83.982 37.8992 72.8802 35.7397 70.1813Z"
          fill="#E4A413"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M36.2691 69.4739C35.0407 67.938 33.3342 65.9289 31.5948 63.9451C31.6149 63.9198 25.0075 57.0082 23.4187 55.3728C21.8295 53.7375 16.262 48.968 15.0908 39.809C14.4781 35.0179 15.9481 27.1983 19.2893 25.0386C16.8787 25.3628 13.5479 29.7316 12.1473 32.4793C7.8032 41.0019 6.81627 40.9815 8.22957 47.896C10.0613 56.8591 16.4792 63.9709 16.7148 64.2069C16.6463 64.277 21.0071 68.7907 21.9144 69.7397C22.6322 70.4911 23.4401 71.3011 24.2688 72.3071C30.8069 79.1284 36.3252 89.4838 37.5212 102.333L48.5631 89.7835C47.1725 83.0372 38.4285 72.1729 36.2691 69.4739Z"
          fill="url(#paint3_radial_11002_1221)"
        />
        <path
          d="M118.15 122.457V128.319H114.47V112.643H120.468C124.557 112.643 127.556 113.597 127.556 117.414C127.556 119.731 126.329 121.094 124.557 121.776L128.374 128.319H124.012L120.604 122.457H118.15ZM118.15 119.322H120.604C122.376 119.322 123.739 119.049 123.739 117.55C123.739 116.05 122.376 115.778 120.604 115.778H118.15V119.322Z"
          fill="#065BAA"
        />
        <path
          d="M133.826 112.643H130.146V128.182H133.826V112.643Z"
          fill="#065BAA"
        />
        <path
          d="M143.641 128.591C138.734 128.591 135.871 125.456 135.871 120.548C135.871 115.641 138.87 112.506 143.777 112.506C147.731 112.506 150.457 115.096 151.002 118.64H147.322C146.913 116.459 145.277 115.641 143.641 115.641C141.46 115.641 139.688 117.413 139.688 120.685C139.688 123.956 141.324 125.728 143.641 125.728C145.277 125.728 147.049 125.047 147.458 122.729H151.138C150.457 126.137 147.458 128.591 143.641 128.591Z"
          fill="#065BAA"
        />
        <path
          d="M160.953 112.643L166.814 128.182H162.861L161.907 125.456H155.909L154.955 128.182H151.002L156.863 112.643H160.953ZM160.953 122.594L158.908 116.596L156.863 122.594H160.953Z"
          fill="#065BAA"
        />
        <path
          d="M171.859 117.55V128.319H168.314V112.643H172.677L178.947 123.411V112.643H182.491V128.319H178.129L171.859 117.55Z"
          fill="#065BAA"
        />
        <path
          d="M193.259 116.868C193.259 117.686 193.941 118.231 195.031 118.504L197.213 118.913C199.666 119.458 202.938 120.14 202.938 123.411C202.938 126.683 199.666 128.591 196.395 128.591C192.441 128.591 189.715 126.546 189.17 123.275H192.85C193.259 124.911 194.486 125.728 196.531 125.728C197.758 125.728 199.257 125.319 199.257 124.093C199.257 123.138 198.03 122.593 196.395 122.184L194.214 121.639C191.624 121.094 189.306 119.867 189.306 117.141C189.306 114.005 192.714 112.506 195.849 112.506C198.985 112.506 201.847 113.869 202.392 117.277H198.712C198.303 116.05 197.213 115.505 195.577 115.505C194.214 115.368 193.259 115.914 193.259 116.868Z"
          fill="#065BAA"
        />
        <path
          d="M216.705 112.643V115.914H208.526V118.64H216.296V121.912H208.526V125.047H216.705V128.319H204.846V112.643H216.705Z"
          fill="#065BAA"
        />
        <path
          d="M226.112 128.591C221.204 128.591 218.342 125.456 218.342 120.548C218.342 115.641 221.341 112.506 226.248 112.506C230.201 112.506 232.928 115.096 233.473 118.64H229.792C229.383 116.459 227.748 115.641 226.112 115.641C223.931 115.641 222.159 117.413 222.159 120.685C222.159 123.956 223.794 125.728 226.112 125.728C227.748 125.728 229.52 125.047 229.929 122.729H233.609C232.928 126.137 229.929 128.591 226.112 128.591Z"
          fill="#065BAA"
        />
        <path
          d="M233.745 115.914V112.643H247.377V115.914H242.333V128.319H238.652V115.914H233.745Z"
          fill="#065BAA"
        />
        <path
          d="M252.693 112.643H249.013V128.182H252.693V112.643Z"
          fill="#065BAA"
        />
        <path
          d="M254.738 120.548C254.738 115.641 258.01 112.506 262.781 112.506C267.552 112.506 270.823 115.777 270.823 120.548C270.823 125.456 267.552 128.591 262.781 128.591C258.01 128.591 254.738 125.319 254.738 120.548ZM267.007 120.548C267.007 117.277 265.098 115.505 262.781 115.505C260.464 115.505 258.555 117.277 258.555 120.548C258.555 123.82 260.464 125.592 262.781 125.592C265.098 125.592 267.007 123.82 267.007 120.548Z"
          fill="#065BAA"
        />
        <path
          d="M276.412 117.55V128.319H272.868V112.643H277.367L283.637 123.411V112.643H287.181V128.319H282.683L276.412 117.55Z"
          fill="#065BAA"
        />
        <path
          d="M73.984 95.0574H76.7103L73.984 106.644H71.1214L69.3493 98.4652L67.5772 106.644H64.7146L61.9883 95.0574H64.8509L66.3504 103.1L67.9861 95.0574H70.7124L72.4845 103.1L73.984 95.0574Z"
          fill="#065BAA"
        />
        <path
          d="M76.9824 100.919C76.9824 97.239 79.4361 94.9216 82.9803 94.9216C86.5245 94.9216 88.9781 97.239 88.9781 100.919C88.9781 104.6 86.5245 106.917 82.9803 106.917C79.4361 106.917 76.9824 104.464 76.9824 100.919ZM86.1155 100.919C86.1155 98.4658 84.7524 97.239 82.9803 97.239C81.3445 97.239 79.845 98.4658 79.845 100.919C79.845 103.373 81.2082 104.6 82.9803 104.6C84.6161 104.6 86.1155 103.373 86.1155 100.919Z"
          fill="#065BAA"
        />
        <path
          d="M93.2048 102.282V106.644H90.4785V95.0574H94.9769C97.9758 95.0574 100.293 95.7389 100.293 98.6016C100.293 100.374 99.339 101.328 97.9758 101.737L100.838 106.508H97.5669L95.1132 102.146H93.2048V102.282ZM93.2048 99.9647H94.9769C96.2037 99.9647 97.2943 99.6921 97.2943 98.6016C97.2943 97.511 96.3401 97.2384 94.9769 97.2384H93.2048V99.9647Z"
          fill="#065BAA"
        />
        <path
          d="M110.381 104.327V106.644H102.065V95.0574H104.792V104.327H110.381Z"
          fill="#065BAA"
        />
        <path
          d="M122.103 100.918C122.103 105.281 119.104 106.78 115.288 106.78H111.471V95.1932H115.288C119.104 95.0569 122.103 96.4201 122.103 100.918ZM114.197 97.3743V104.326H115.288C117.332 104.326 119.104 103.917 119.104 100.782C119.104 97.7832 117.332 97.238 115.288 97.238H114.197V97.3743Z"
          fill="#065BAA"
        />
        <path
          d="M135.326 95.0574V102.282C135.326 105.145 133.826 106.917 130.827 106.917C127.829 106.917 126.329 105.008 126.329 102.282H129.055C129.055 104.19 129.737 104.736 130.827 104.736C131.918 104.736 132.6 104.19 132.6 102.282V95.0574H135.326Z"
          fill="#065BAA"
        />
        <path
          d="M146.367 95.0574V97.511H140.096V99.5558H145.958V102.009H140.096V104.327H146.367V106.644H137.37V95.0574H146.367Z"
          fill="#065BAA"
        />
        <path
          d="M158.908 95.0574H161.635L159.045 106.644H156.182L154.41 98.4652L152.638 106.644H149.639L147.049 95.0574H149.775L151.411 103.1L152.91 95.0574H155.773L157.545 103.1L158.908 95.0574Z"
          fill="#065BAA"
        />
        <path
          d="M165.588 95.0574H162.861V106.644H165.588V95.0574Z"
          fill="#065BAA"
        />
        <path
          d="M169.95 98.1926C169.95 98.7379 170.495 99.1468 171.313 99.4194L172.949 99.6921C174.857 100.101 177.175 100.646 177.175 103.1C177.175 105.554 174.721 106.917 172.267 106.917C169.269 106.917 167.36 105.417 166.951 102.964H169.677C169.95 104.19 170.904 104.736 172.404 104.736C173.358 104.736 174.448 104.463 174.448 103.509C174.448 102.691 173.494 102.418 172.267 102.146L170.904 101.873C168.996 101.464 167.36 100.51 167.36 98.4652C167.36 96.1479 169.95 95.0574 172.131 95.0574C174.449 95.0574 176.493 96.0116 176.902 98.6016H174.176C173.903 97.7837 173.085 97.2384 171.859 97.2384C170.768 97.1021 169.95 97.511 169.95 98.1926Z"
          fill="#065BAA"
        />
        <path
          d="M188.761 106.644H186.034V102.009H181.263V106.644H178.537V95.0574H181.263V99.5558H186.034V95.0574H188.761V106.644Z"
          fill="#065BAA"
        />
        <path
          d="M199.666 106.917C195.986 106.917 193.805 104.6 193.805 100.919C193.805 97.239 196.122 94.9216 199.666 94.9216C202.529 94.9216 204.574 96.83 204.983 99.42H202.256C201.984 97.7843 200.757 97.1027 199.53 97.1027C197.894 97.1027 196.667 98.4658 196.667 100.783C196.667 103.237 197.894 104.6 199.53 104.6C200.757 104.6 201.984 104.055 202.393 102.283H205.119C204.71 105.009 202.529 106.917 199.666 106.917Z"
          fill="#065BAA"
        />
        <path
          d="M206.073 100.919C206.073 97.239 208.527 94.9216 212.071 94.9216C215.615 94.9216 218.069 97.239 218.069 100.919C218.069 104.6 215.615 106.917 212.071 106.917C208.527 106.917 206.073 104.464 206.073 100.919ZM215.206 100.919C215.206 98.4658 213.843 97.239 212.071 97.239C210.299 97.239 208.936 98.4658 208.936 100.919C208.936 103.373 210.299 104.6 212.071 104.6C213.843 104.6 215.206 103.373 215.206 100.919Z"
          fill="#065BAA"
        />
        <path
          d="M222.158 98.7379V106.644H219.568V95.0574H222.976L227.611 103.1V95.0574H230.201V106.644H226.929L222.158 98.7379Z"
          fill="#065BAA"
        />
        <path
          d="M240.152 98.7379C239.879 97.92 239.061 97.2384 237.562 97.2384C235.926 97.2384 234.563 98.4652 234.563 100.919C234.563 103.373 235.79 104.736 237.562 104.736C238.789 104.736 240.152 104.19 240.152 102.827V102.555H237.289V100.374H242.878V106.78H240.833L240.697 105.554C239.879 106.508 238.789 107.053 237.153 107.053C233.745 107.053 231.7 104.736 231.7 101.055C231.7 97.3747 234.154 95.0574 237.562 95.0574C240.152 95.0574 242.196 96.4205 242.742 98.8742H240.152V98.7379Z"
          fill="#065BAA"
        />
        <path
          d="M247.65 102.282V106.644H244.924V95.0574H249.422C252.421 95.0574 254.739 95.7389 254.739 98.6016C254.739 100.374 253.784 101.328 252.421 101.737L255.284 106.508H252.012L249.559 102.146H247.65V102.282ZM247.65 99.9647H249.422C250.649 99.9647 251.74 99.6921 251.74 98.6016C251.74 97.511 250.785 97.2384 249.422 97.2384H247.65V99.9647Z"
          fill="#065BAA"
        />
        <path
          d="M265.507 95.0574V97.511H259.373V99.5558H265.098V102.009H259.373V104.327H265.507V106.644H256.646V95.0574H265.507Z"
          fill="#065BAA"
        />
        <path
          d="M269.46 98.1926C269.46 98.7379 270.005 99.1468 270.823 99.4194L272.459 99.6921C274.367 100.101 276.685 100.646 276.685 103.1C276.685 105.554 274.231 106.917 271.777 106.917C268.778 106.917 266.87 105.417 266.461 102.964H269.187C269.46 104.19 270.414 104.736 271.914 104.736C272.868 104.736 273.958 104.463 273.958 103.509C273.958 102.691 273.004 102.418 271.777 102.146L270.414 101.873C268.506 101.464 266.87 100.51 266.87 98.4652C266.87 96.1479 269.46 95.0574 271.641 95.0574C273.958 95.0574 276.003 96.0116 276.412 98.6016H273.686C273.413 97.7837 272.595 97.2384 271.368 97.2384C270.278 97.1021 269.46 97.511 269.46 98.1926Z"
          fill="#065BAA"
        />
        <path
          d="M280.638 98.1926C280.638 98.7379 281.183 99.1468 282.001 99.4194L283.637 99.6921C285.545 100.101 287.862 100.646 287.862 103.1C287.862 105.554 285.409 106.917 282.955 106.917C279.956 106.917 278.048 105.417 277.639 102.964H280.365C280.638 104.19 281.592 104.736 283.091 104.736C284.045 104.736 285.136 104.463 285.136 103.509C285.136 102.691 284.182 102.418 282.955 102.146L281.592 101.873C279.683 101.464 278.048 100.51 278.048 98.4652C278.048 96.1479 280.638 95.0574 282.819 95.0574C285.136 95.0574 287.181 96.0116 287.59 98.6016H284.863C284.591 97.7837 283.773 97.2384 282.546 97.2384C281.319 97.1021 280.638 97.511 280.638 98.1926Z"
          fill="#065BAA"
        />
        <path
          d="M272.323 18.7207C260.055 18.7207 250.104 28.6717 250.104 40.9401C250.104 53.2084 260.055 63.1594 272.323 63.1594C284.591 63.1594 294.542 53.2084 294.542 40.9401C294.542 28.6717 284.591 18.7207 272.323 18.7207ZM267.961 21.8559C263.326 26.4907 260.191 33.0338 259.918 39.9858H252.83C253.102 31.1254 259.509 23.7644 267.961 21.8559ZM252.83 42.5758H259.918C260.191 49.3916 263.19 55.5258 267.824 60.0242C259.646 58.1157 253.511 51.1637 252.83 42.5758ZM270.96 59.6152C266.052 55.5258 262.781 49.5279 262.372 42.7121H270.96V59.6152ZM270.96 39.9858H262.372C262.781 33.0338 266.052 26.627 270.96 22.5375V39.9858ZM291.952 39.9858H284.864C284.591 33.0338 281.456 26.4907 276.958 21.8559C285.136 23.9007 291.543 31.1254 291.952 39.9858ZM273.55 22.4012C278.321 26.4907 281.729 33.0338 282.138 39.9858H273.55V22.4012ZM273.55 59.4789V42.5758H282.138C281.865 49.5279 278.593 55.5258 273.55 59.4789ZM276.958 60.0242C281.592 55.5258 284.455 49.3916 284.864 42.5758H291.952C291.134 51.1637 285 58.1157 276.958 60.0242Z"
          fill="#065BAA"
        />
        <path
          d="M246.15 40.9403C246.15 26.4909 257.873 14.6315 272.459 14.6315C277.775 14.6315 282.819 15.4494 287.044 18.1757V3.31737C282.546 1.54527 277.639 0.591064 272.459 0.591064C253.375 0.591064 237.426 13.8136 233.2 31.5346V2.63579V0.591064H199.121L180.855 41.2129L162.725 0.591064H160.68L144.731 42.7124L133.69 23.7646L132.054 26.6272L122.648 42.8487L144.731 81.4259H147.049L161.771 44.4845L179.355 81.4259H181.673L215.752 6.72524V57.8434C215.752 65.7496 204.983 69.4302 197.485 60.706L190.942 75.0191C195.168 78.9722 201.847 81.4259 207.3 81.4259C212.071 81.4259 216.161 80.7443 219.705 79.1085C222.704 77.7454 227.338 74.2012 229.247 70.657C232.246 65.3407 232.927 60.1607 233.064 50.3461C237.289 68.067 253.375 81.4259 272.322 81.4259C277.502 81.4259 282.41 80.4717 286.908 78.6996V63.7049C282.682 66.4312 277.775 67.2491 272.322 67.2491C257.873 67.2491 246.15 55.526 246.15 40.9403Z"
          fill="#065BAA"
        />
        <path
          d="M127.148 18.1758H130.283L120.196 0.86377H98.6582L108.473 18.1758H127.148Z"
          fill="#065BAA"
        />
        <path
          d="M127.147 23.765H104.927L93.8859 4.68091L82.8443 23.765H60.625L71.6665 42.9854L60.625 62.2059H82.8443L93.8859 81.4263L104.927 62.2059H127.147L115.969 42.9854L127.147 23.765Z"
          fill="#065BAA"
        />
        <path
          d="M112.016 112.643V115.914H103.837V118.64H111.607V121.912H103.837V125.047H112.016V128.319H100.156V112.643H112.016Z"
          fill="#065BAA"
        />
        <path
          d="M83.1174 115.778V128.319H79.5732V112.643H85.4348L88.4337 123.957L91.4327 112.643H97.1579V128.319H93.6137V115.778L90.0695 128.319H86.6616L83.1174 115.778Z"
          fill="#065BAA"
        />
        <path
          d="M72.2117 112.643L78.0733 128.182H74.1201L73.1659 125.456H67.1681L66.2139 128.182H62.2607L68.1223 112.643H72.2117ZM72.2117 122.594L70.167 116.596L68.1223 122.594H72.2117Z"
          fill="#065BAA"
        />
        <defs>
          <radialGradient
            id="paint0_radial_11002_1221"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(24.1482 37.5488) scale(15.4734 15.4736)"
          >
            <stop stop-color="#FEBE0F" />
            <stop offset="1" stop-color="#DE9616" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_11002_1221"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(24.4518 59.4092) scale(34.9767 34.9773)"
          >
            <stop stop-color="#FFE900" />
            <stop offset="0.28" stop-color="#FFF8A3" />
            <stop offset="0.56" stop-color="#FFF572" />
            <stop offset="1" stop-color="#FFC20D" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_11002_1221"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(24.5401 64.5531) scale(35.9802 35.9809)"
          >
            <stop stop-color="#EFAC13" />
            <stop offset="0.18" stop-color="#F5C107" />
            <stop offset="0.47" stop-color="#F6CE1F" />
            <stop offset="0.7" stop-color="#FFD400" />
            <stop offset="1" stop-color="#FEBE0F" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_11002_1221"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(26.3525 67.5392) rotate(-121.413) scale(49.3274 49.327)"
          >
            <stop stop-color="#F6CE1F" />
            <stop offset="0.26" stop-color="#FFDF00" />
            <stop offset="0.57" stop-color="#FACD02" />
            <stop offset="1" stop-color="#EAA514" />
          </radialGradient>
        </defs>
      </svg>
      <h1
        class="font-suisse-works text-blue-donation text-xl sm:text-5 md:text-xl lg:text-7 xl:text-2xl my-2 sm:my-1.5 md:my-2 xl:my-3"
      >
        A Kippah Should Not Be A Target For Hate
      </h1>
      <span
        class="font-suisse-intl text-blue-donation text-sm sm:text-xs md:text-sm lg:text-base mb-5 sm:mb-4 md:mb-6 xl:mb-8"
      >
        Please make a gift to the World Jewish Congress, American Section, today
        to help WJC reach our urgent end-of-month goal.  Together, we will build
        a safer and brighter Jewish future.
      </span>
      <div
        class="w-full flex items-center justify-between gap-x-5 sm:gap-x-3 md:gap-x-5 lg:gap-x-6 xl:gap-x-8"
      >
        <button
          @click="setAmount(57.85)"
          class="donation-button"
          :class="
            crazyAmount ? 'bg-blue-donation text-white' : 'text-blue-donation'
          "
        >
          $57.85
        </button>
        <button
          @click="setAmount(180)"
          class="donation-button"
          :class="
            amount == 180 ? 'bg-blue-donation text-white' : 'text-blue-donation'
          "
        >
          $180
        </button>
        <button
          @click="setAmount(250)"
          class="donation-button"
          :class="
            amount == 250 ? 'bg-blue-donation text-white' : 'text-blue-donation'
          "
        >
          $250
        </button>
      </div>
      <input
        type="number"
        :value="customAmount"
        @input="handleCustomInput"
        @keydown="preventNegative"
        min="0"
        class="px-2 lg:px-3 xl:px-4 font-suisse-intl text-blue-donation text-base sm:text-xs md:text-sm lg:text-base xl:text-5 font-medium w-full h-11 sm:h-7 md:h-8 lg:h-9 xl:h-11 my-2 sm:my-1 md:my-2 xl:my-3 border-2 border-solid border-blue-donation rounded-md"
        placeholder="Other amount"
      />
      <div
        class="w-full flex items-center gap-x-1 lg:gap-x-2 mb-5 sm:mb-4 md:mb-6 xl:mb-8"
      >
        <input
          type="checkbox"
          v-model="monthly"
          class="h-3 w-3 lg:h-4 lg:w-4"
        />
        <span
          class="font-suisse-intl text-blue-donation text-sm sm:text-xs lg:text-sm xl:text-base"
          >Make this a monthly donation</span
        >
      </div>
      <a
        v-if="crazyAmount"
        :href="
          monthly
            ? `https://support.worldjewishcongress.org/page/83481/donate/1?ea.tracking.id=O5251L00&transaction&transaction.recurrpay=Y`
            : `https://support.worldjewishcongress.org/page/83481/donate/1?ea.tracking.id=O5251L00&transaction`
        "
        class="cursor-pointer w-full bg-blue-donation font-suisse-intl text-white font-medium text-base sm:text-xs lg:text-sm xl:text-base rounded-full border border-solid border-primary h-11 sm:h-7 md:h-8 lg:h-9 xl:h-11 flex items-center justify-center"
      >
        HELP NOW
      </a>
      <a
        v-else
        :href="
          monthly
            ? `https://support.worldjewishcongress.org/page/83481/donate/1?ea.tracking.id=O5251L00&transaction.donationAmt=${amount}&transaction.recurrpay=Y`
            : `https://support.worldjewishcongress.org/page/83481/donate/1?ea.tracking.id=O5251L00&transaction.donationAmt=${amount}`
        "
        class="cursor-pointer w-full bg-blue-donation font-suisse-intl text-white font-medium text-base sm:text-xs lg:text-sm xl:text-base rounded-full border border-solid border-primary h-11 sm:h-7 md:h-8 lg:h-9 xl:h-11 flex items-center justify-center"
      >
        HELP NOW
      </a>
      <!-- <div class="text-primary text-2xl">{{ amount }}</div> -->
      <!-- <div class="text-primary text-2xl">{{ monthly }}</div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      amount: 0,
      crazyAmount: false,
      customAmount: '',
      monthly: false
    };
  },

  methods: {
    setAmount(donation) {
      if (donation == 57.85) {
        this.crazyAmount = true;
        this.amount = undefined;
        return;
      } else {
        this.crazyAmount = false;
      }
      this.amount = donation;
      this.customAmount = '';
    },
    handleCustomInput(event) {
      const val = event.target.value;
      this.customAmount = val;
      const parsed = parseFloat(val);
      if (!isNaN(parsed)) {
        this.amount = val;
      } else {
        this.amount = 0; // or null if you prefer
      }
    },
    preventNegative(event) {
      if (event.key === '-' || event.key === 'Minus') {
        event.preventDefault();
      }
    },
    handleClick(event) {
      if (this.amount === 0) {
        // Do nothing (link will not be followed due to `.prevent`)
        return;
      }
      // Otherwise, manually follow the link if needed (optional)
      window.location.href = event.currentTarget.href;
    }
  }
};
</script>
<style>
.bg-box {
  background: #fefbf4 url('../../images/donation-popup-bg.png');
}
.img-box {
  background-image: url('../../images/donation-popup-img-small.png');
  @screen sm {
    background-image: url('../../images/donation-popup-img.png');
  }
}
.donation-box {
  height: 660px;
  width: 360px;
  @screen sm {
    height: 400px;
    width: 100%;
  }
  @screen md {
    height: 500px;
  }
  @screen lg {
    height: 600px;
  }
  @screen xl {
    height: 800px;
  }
}
input[type='checkbox'] {
  accent-color: #065baa;
  border-radius: 2px;
}
.donation-popup {
  .modal-close-button {
    background-color: unset;
    background-size: cover !important;
    background-position: center !important;
    background: url('../../images/icons/donation-close.svg');
    right: unset;
    left: 16px;
    top: 16px;
    padding: unset;
    height: 40px;
    width: 40px;
    @screen sm {
      height: 30px;
      width: 30px;
    }
    @screen md {
      height: 35px;
      width: 35px;
    }
    @screen lg {
      height: 40px;
      width: 40px;
    }
    @screen xl {
      height: 50px;
      width: 50px;
    }

    &:hover {
      background-color: unset;
    }
    &:focus {
      box-shadow: unset;
    }
  }
}
.donation-button {
  @apply bg-white font-suisse-intl font-medium rounded-md w-full border-2 border-solid flex items-center justify-center h-11;
  border-color: #065baa;
  @screen sm {
    @apply h-7 text-xs;
  }
  @screen md {
    @apply h-8 text-sm;
  }
  @screen lg {
    @apply h-9 text-base;
  }
  @screen xl {
    @apply h-11 text-5;
  }
}
.donation-logo {
  width: 113px;
  height: 48px;
  @screen sm {
    width: 90px;
    height: 40px;
  }
  @screen md {
    width: 110px;
    height: 48px;
  }
  @screen lg {
    width: 125px;
    height: 55px;
  }
  @screen xl {
    width: 145px;
    height: 63px;
  }
}
</style>
